// extracted by mini-css-extract-plugin
export var formContainer = "_kv-0";
export var message = "_kv-1";